import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Chip,
  Grid,
  IconButton,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import CategoryIcon from "@mui/icons-material/Category";
import AddchartIcon from "@mui/icons-material/Addchart";
import axios from "axios";
import { useRecoilValue } from "recoil";
import { authState } from "../../recoil/authAtom";
import { BASE_URL } from "../../constants";
const Widal = ({
  test,
  widalInvestigation,
  setOpenModal,
  selectedTest,
  handleDisableTest,
  disableLoading,
}) => {
  const user = useRecoilValue(authState);
  const [widalInvestigations, setwidalInvestigations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setwidalInvestigations(widalInvestigation);
  }, [widalInvestigation]);

  const handleAddInput = () => {
    if (widalInvestigations.length < 6) {
      setwidalInvestigations([...widalInvestigations, { name: "" }]);
    }
  };

  const handleRemoveInput = (index) => {
    if (widalInvestigations.length > 1) {
      const updatedwidalInvestigations = widalInvestigations.filter(
        (_, i) => i !== index,
      );
      setwidalInvestigations(updatedwidalInvestigations);
    }
  };

  const handleChange = (index, value) => {
    const updatedwidalInvestigations = [...widalInvestigations];
    updatedwidalInvestigations[index].name = value;
    setwidalInvestigations(updatedwidalInvestigations);
  };

  const handleSubmit = async () => {
    console.log(widalInvestigations);
    try {
      setLoading(true);
      const response = await axios.post(
        `${BASE_URL}api/user/pathology/create-widal-investigation/${test._id}`,
        widalInvestigations,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const resp = response.data;
      alert(resp.message);
      window.location.reload();
      // Optional: Reset form if needed
      // setwidalInvestigations(["", ""]);
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async () => {
    console.log(widalInvestigations);
    try {
      setLoading(true);
      const response = await axios.post(
        `${BASE_URL}api/user/pathology/update-widal-investigation/${test._id}`,
        widalInvestigations,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      const resp = response.data;
      alert(resp.message);
      // Optional: Reset form if needed
      // setwidalInvestigations(["", ""]);
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ mt: 3, p: 3 }}>
      <div>
        <Chip avatar={<AddchartIcon />} label={test && test.testName} />
        <Chip
          avatar={<CategoryIcon />}
          label={test && test.testCat}
          sx={{ marginX: 1 }}
        />
        <Chip avatar={<CurrencyRupeeIcon />} label={test && test.testPrice} />
        {/* {user?._doc?.permissions?.testHeaderManagement?.edit && (
          <Button onClick={() => setOpenModal(true)}>Edit Header</Button>
        )} */}
        {user?._doc?.permissions?.testHeaderManagement?.edit && (
          <>
            <Button
              variant="contained"
              size="small"
              color="success"
              style={{ fontSize: "10px", margin: "0px 3px" }}
              onClick={() => setOpenModal(true)}
            >
              Edit Header
            </Button>

            {selectedTest?.isEnabled ? (
              <Button
                variant="outlined"
                color="error"
                size="small"
                style={{ fontSize: "10px" }}
                onClick={() => handleDisableTest()}
                disabled={disableLoading}
              >
                {disableLoading ? "Disabling..." : "Disable Test"}
              </Button>
            ) : (
              <Button
                variant="outlined"
                color="success"
                size="small"
                style={{ fontSize: "10px" }}
                onClick={() => handleDisableTest()}
                disabled={disableLoading}
              >
                {disableLoading ? "Enabling..." : "Enable Test"}
              </Button>
            )}
          </>
        )}
      </div>

      <Grid container spacing={2} mt={1}>
        {widalInvestigations.map((input, index) => (
          <Grid item xs={6} key={index}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <TextField
                fullWidth
                required
                label={`Antibody Titre ${index + 1}`}
                value={input.name}
                onChange={(e) => handleChange(index, e.target.value)}
                variant="outlined"
              />
              <div
                style={{
                  backgroundColor: "#fff0f3",
                  marginLeft: "5px",
                  padding: "8px",
                  borderRadius: "5px",
                }}
              >
                <IconButton
                  onClick={() => handleRemoveInput(index)}
                  disabled={widalInvestigations.length <= 1}
                  sx={{ color: "#ff4d6d" }}
                >
                  <Delete />
                </IconButton>
              </div>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          variant="outlined"
          startIcon={<Add />}
          color="warning"
          onClick={handleAddInput}
          disabled={widalInvestigations.length >= 5}
          sx={{ mt: 3, width: "25%" }}
        >
          Antibody Titre
        </Button>
        {widalInvestigation?.length === 0 ? (
          <Button
            variant="contained"
            color="success"
            onClick={handleSubmit}
            sx={{ mt: 3, width: "15%" }}
          >
            Save
          </Button>
        ) : (
          <Button
            variant="contained"
            color="warning"
            onClick={handleEdit}
            sx={{ mt: 3, width: "15%" }}
          >
            Update
          </Button>
        )}
      </Box>
    </Paper>
  );
};

export default Widal;
